/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Preset_Load_PlaceholderInputs */

const en_audio_description_export_preset_load_placeholder = /** @type {(inputs: Audio_Description_Export_Preset_Load_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a preset`)
};

const fr_audio_description_export_preset_load_placeholder = /** @type {(inputs: Audio_Description_Export_Preset_Load_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisir un préréglage`)
};

const de_audio_description_export_preset_load_placeholder = /** @type {(inputs: Audio_Description_Export_Preset_Load_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie eine Voreinstellung.`)
};

const it_audio_description_export_preset_load_placeholder = /** @type {(inputs: Audio_Description_Export_Preset_Load_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli un preset`)
};

const ru_audio_description_export_preset_load_placeholder = /** @type {(inputs: Audio_Description_Export_Preset_Load_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите предустановку`)
};

const es_audio_description_export_preset_load_placeholder = /** @type {(inputs: Audio_Description_Export_Preset_Load_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elija un ajuste preestablecido`)
};

const zh_cn2_audio_description_export_preset_load_placeholder = /** @type {(inputs: Audio_Description_Export_Preset_Load_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择预设`)
};

const ja_audio_description_export_preset_load_placeholder = /** @type {(inputs: Audio_Description_Export_Preset_Load_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットを選択`)
};

const hi_audio_description_export_preset_load_placeholder = /** @type {(inputs: Audio_Description_Export_Preset_Load_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक प्रीसेट चुनें`)
};

const pt_pt2_audio_description_export_preset_load_placeholder = /** @type {(inputs: Audio_Description_Export_Preset_Load_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha uma predefinição`)
};

/**
* | output |
* | --- |
* | "Choose a preset" |
*
* @param {Audio_Description_Export_Preset_Load_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_preset_load_placeholder = /** @type {((inputs?: Audio_Description_Export_Preset_Load_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Preset_Load_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_preset_load_placeholder(inputs)
	if (locale === "de") return de_audio_description_export_preset_load_placeholder(inputs)
	if (locale === "it") return it_audio_description_export_preset_load_placeholder(inputs)
	if (locale === "ru") return ru_audio_description_export_preset_load_placeholder(inputs)
	if (locale === "es") return es_audio_description_export_preset_load_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_preset_load_placeholder(inputs)
	if (locale === "ja") return ja_audio_description_export_preset_load_placeholder(inputs)
	if (locale === "hi") return hi_audio_description_export_preset_load_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_preset_load_placeholder(inputs)
	return en_audio_description_export_preset_load_placeholder(inputs)
});